import { action, observable, reaction, makeObservable } from 'mobx';
import {SuccessResponse, uploadedFiles} from '../../../../../../domain';
import {
  BooleanControl,
  Disposers,
  HttpPromiseState,
  StringControl,
  toInt,
  validators
} from '../../../../../../lib/helpers';

export class MQDataPairStore {
  left: StringControl;
  right: StringControl;
  fixed: BooleanControl;

  @observable.ref
  selectedFile: File | null;
  @observable.ref
  uploadState: HttpPromiseState<SuccessResponse> | null;

  private readonly disposers: Disposers;

  constructor() {
    makeObservable(this);
    this.left = new StringControl('left', '', validators.required);
    this.right = new StringControl('right', '', validators.required);
    this.fixed = new BooleanControl('fixed', false);
    this.selectedFile = null;
    this.uploadState = null;
    this.disposers = new Disposers();
    this.setup();
  }

  @action
  setSelectedFile = (file: File | null) => {
    this.selectedFile = file;
  };

  @action
  upload = () => {
    if (this.selectedFile === null)
      return;
    if (this.uploadState?.isPending === true)
      return;
    this.uploadState = uploadedFiles.uploadImage(this.selectedFile);
  };

  @action
  ensureLeftSideUrl = () => {
    const value = this.left.value;
    if (uploadedFiles.isImageUrl(value))
      return;
    this.left.setValue('');
  };

  setup() {
    this.disposers.add(
      reaction(
        () => this.uploadState?.state,
        this.afterFileUploaded
      ));
  }

  @action
  afterFileUploaded = () => {
    if (this.uploadState?.isResolved !== true)
      return;

    const tmp = this.uploadState.value.Results.Id;
    const id = toInt(tmp);
    if (id === null)
      return;

    this.selectedFile = null;
    this.uploadState = null;
    this.left.setValue(uploadedFiles.imageUrl(id));
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
